module.exports = __webpack_public_path__ + "img/industrial_audi.4bfeca6e.jpg";